const SOURCE_LABELS: Record<string, string> = {
  stagecrew: 'StageCrew',
  linkedin: 'LinkedIn',
  craigslist: 'Craigslist',
  indeed: 'Indeed',
  greenhouse: 'Employer job board',
  workday: 'Employer job board',
  encore: 'Employer job board',
  simplyhired: 'SimplyHired',
  staffmeup: 'StaffMeUp',
  entertainmentcareers: 'EntertainmentCareers',
};

export const formatJobSource = (source: string): string => {
  const normalizedSource = String(source || '').trim().toLowerCase();
  return SOURCE_LABELS[normalizedSource]
    || normalizedSource.replace(/\b\w/g, character => character.toUpperCase());
};
